import React from 'react';
//@ts-ignore
import Fade from 'react-reveal/Fade';
import Standup from '../../assets/images/standup.svg';
import Code from '../../assets/images/code.svg';
import Test from '../../assets/images/test.svg';
import './Process.css';

export default function Process(){
    return  <>
                <div className="md:mt-48" id="behindday">
                    <div className="md:flex ">
                            <Fade bottom>
                                <div className="w-full text-center">
                                    <h2 className="title-text dark-text">Our Process</h2>
                                </div>
                            </Fade>
                        </div>
                        <div className="md:flex text-center mt-12">
                            <div className="w-full md:w-1/3  px-16 py-4">
                                <Fade bottom>
                                    <h3 className="subtitle-text dark-text">Daily Standup</h3>
                                    <div className="h-60">
                                    <img className="h-48 mt-6 mb-6 mx-auto" src={Standup} alt="Daily Standup" />
                                    </div>
                                    
                                    <p className="text-gray">Great communication is the most important characteristic for success in a project, between clients, developers and users. </p>
                                </Fade>
                            </div>
                            <div className="w-full md:w-1/3 px-16  py-4">
                                <Fade bottom>
                                    <h3 className="subtitle-text dark-text">Coding</h3>
                                    <div className="h-60">
                                        <img className="h-48 mt-6 mb-6 mx-auto"  src={Code} alt="Coding" />
                                    </div>
                                    <p className="text-gray">We love coding, good practices and tons of coffee! We learn new frameworks, languages and technologies  everyday.</p>
                                </Fade>
                            </div>
                            <div className="w-full md:w-1/3 px-16 py-4">
                                <Fade bottom>
                                    <h3 className="subtitle-text dark-text">User testing</h3>
                                    <div className="h-60">
                                        <img className="h-48 mt-6 mb-6 mx-auto"  src={Test} alt="User testing" />
                                    </div>
                                    
                                    <p className="text-gray">“Geeks are people who love something so much that all the details matter.”— Marissa Mayer, Yahoo! CEO </p>
                                </Fade>
                            </div>
                        </div>
                </div>
         </>
}